const VARIANTS = [
  {
    title: 'Классическая',
    desc: 'Строгие вертикальные прутья, ровные линии, лаконичный рисунок. Сдержанный и благородный вариант, подходящий к любому памятнику.',
    specs: 'Строгий дизайн',
    imageUrl: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/e793d42fb0bd275025feba195c6655ce.jpeg',
  },
  {
    title: 'С завитками',
    desc: 'Плавные изогнутые элементы, вензеля и спирали. Традиционный рисунок, который придаёт оградке изящество и выразительность.',
    specs: 'Традиционный узор',
    imageUrl: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/c05c790ad3e5281ebddaf760416b0eef.jpeg',
  },
  {
    title: 'С цветочными мотивами',
    desc: 'Кованые цветы, листья, растительный орнамент. Живой и тёплый рисунок — деликатное украшение места памяти.',
    specs: 'Растительный орнамент',
    imageUrl: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/bc3f6732dd5b8535e105faf45cb878f0.jpeg',
  },
  {
    title: 'С крестами',
    desc: 'Кованый крест как центральный элемент композиции. Строгий и величественный — для тех, кому важна духовная символика.',
    specs: 'Духовная символика',
    imageUrl: 'https://readdy.ai/api/search-image?query=Wrought%20iron%20grave%20fence%20with%20prominent%20cross%20design%20integrated%20into%20metalwork%20dark%20charcoal%20finish%20in%20a%20quiet%20cemetery%20with%20green%20grass%20and%20trees%20soft%20natural%20daylight%20solemn%20dignified%20atmosphere%20realistic%20architectural%20photography%20clean%20composition&width=800&height=600&seq=var-grave-cross&orientation=landscape',
  },
  {
    title: 'По индивидуальному эскизу',
    desc: 'Ваш рисунок, наш металл. Присылайте эскиз или описание — воспроизведём в ковке с точностью до деталей.',
    specs: 'Ваш уникальный проект',
    imageUrl: 'https://readdy.ai/api/search-image?query=Custom%20designed%20wrought%20iron%20grave%20fence%20with%20unique%20personalized%20metalwork%20pattern%20dark%20charcoal%20finish%20artisan%20craftsmanship%20in%20a%20quiet%20cemetery%20setting%20green%20grass%20and%20trees%20soft%20natural%20daylight%20respectful%20bespoke%20design%20realistic%20architectural%20photography%20clean%20composition&width=800&height=600&seq=var-grave-custom&orientation=landscape',
  },
];

const WHATSAPP_MSG = encodeURIComponent('Здравствуйте! Хочу рассчитать стоимость кованой оградки. Интересует вариант: ');

export default function VariantsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1400px' }}>
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Варианты исполнения
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Пять вариантов — от&nbsp;строгой классики до&nbsp;индивидуального проекта по&nbsp;вашему&nbsp;эскизу
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {VARIANTS.map((variant, idx) => (
            <div
              key={variant.title}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden transition-all duration-400 hover:border-primary-200/50 flex flex-col animate-fade-in-up"
              style={{ animationDelay: `${idx * 0.08}s` }}
            >
              <div className="relative w-full h-52 md:h-60 overflow-hidden shrink-0">
                <img
                  src={variant.imageUrl}
                  alt={variant.title}
                  className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="p-5 md:p-6 flex flex-col flex-1">
                <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">{variant.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3 flex-1">{variant.desc}</p>
                <p className="text-xs font-medium text-accent-600 mb-4 bg-accent-100 inline-block self-start px-2.5 py-1 rounded-full">{variant.specs}</p>
                <a
                  href={`https://wa.me/79174131562?text=${WHATSAPP_MSG}${encodeURIComponent(variant.title.toLowerCase() + '.')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm px-5 py-2.5 rounded-md transition-all duration-300 cursor-pointer text-center"
                >
                  Узнать стоимость
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}